import { css } from '@linaria/atomic';

const thumbSize = 'var(--fabric-number-n-3-5-px)';

export const playbackRootStyle = css`
  align-items: center;
  background-color: var(--fabric-color-surface-default);
  border-top-width: 1px;
  border-right-width: 1px;
  border-bottom-width: 1px;
  border-left-width: 1px;
  border-top-style: solid;
  border-right-style: solid;
  border-bottom-style: solid;
  border-left-style: solid;
  border-top-color: var(--fabric-color-border-subtle);
  border-right-color: var(--fabric-color-border-subtle);
  border-bottom-color: var(--fabric-color-border-subtle);
  border-left-color: var(--fabric-color-border-subtle);
  border-top-left-radius: var(--fabric-radius-sm);
  border-top-right-radius: var(--fabric-radius-sm);
  border-bottom-right-radius: var(--fabric-radius-sm);
  border-bottom-left-radius: var(--fabric-radius-sm);
  display: inline-flex;
  max-width: 100%;
  min-width: 0;
  width: fit-content;
`;

export const inlineRootStyle = css`
  row-gap: var(--fabric-space-gap-xxs);
  column-gap: var(--fabric-space-gap-xxs);
  height: var(--fabric-number-n-10-px);
  width: 100%;
`;

export const compactRootStyle = css`
  display: inline-flex;
  row-gap: var(--fabric-number-n-1-px);
  column-gap: var(--fabric-number-n-1-px);
  height: var(--fabric-number-n-8-px);
  padding-inline-start: var(--fabric-space-padding-xxs);
  padding-inline-end: var(--fabric-space-padding-xxs);
`;

export const compactMenuStyle = css`
  align-items: center;
  display: flex;
  flex-direction: row;
  row-gap: var(--fabric-number-n-2-px);
  column-gap: var(--fabric-number-n-2-px);
  padding-top: var(--fabric-space-padding-xxs);
  padding-right: var(--fabric-space-padding-xxs);
  padding-bottom: var(--fabric-space-padding-xxs);
  padding-left: var(--fabric-space-padding-xxs);
  width: min(calc(100vw - var(--fabric-number-n-2-px)), 290px);
  height: 32px;
`;

export const compactCollapsedStyle = css`
  align-self: stretch;
  align-items: center;
  display: inline-flex;
  row-gap: var(--fabric-number-n-1-px);
  column-gap: var(--fabric-number-n-1-px);
`;

export const compactTimeStyle = css`
  color: var(--fabric-color-text-secondary);
  font-size: var(--fabric-font-size-sm);
  font-feature-settings: 'tnum';
  font-variant-numeric: tabular-nums;
  text-align: center;
  white-space: nowrap;
  width: 10ch;
`;

export const inlineProgressGroupStyle = css`
  align-items: center;
  display: inline-flex;
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: auto;
  row-gap: var(--fabric-number-n-1-px);
  column-gap: var(--fabric-number-n-1-px);
  min-width: 0;
  width: 100%;
`;

export const inlineTimeStyle = css`
  color: var(--fabric-color-text-secondary);
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: auto;
  font-size: var(--fabric-font-size-sm);
  font-feature-settings: 'tnum';
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
`;

export const progressStyle = css`
  -webkit-appearance: none;
  appearance: none;
  background-image: linear-gradient(
    to right,
    var(--fabric-color-action-primary-background-default) 0%,
    var(--fabric-color-action-primary-background-default) var(--audio-progress),
    var(--fabric-color-border-subtle) var(--audio-progress),
    var(--fabric-color-border-subtle) 100%
  );
  border-top-width: 0;
  border-right-width: 0;
  border-bottom-width: 0;
  border-left-width: 0;
  border-top-left-radius: var(--fabric-radius-sm);
  border-top-right-radius: var(--fabric-radius-sm);
  border-bottom-right-radius: var(--fabric-radius-sm);
  border-bottom-left-radius: var(--fabric-radius-sm);
  cursor: pointer;
  height: 6px;
  margin-top: 0;
  margin-right: 0;
  margin-bottom: 0;
  margin-left: 0;
  outline-style: none;
  padding-top: 0;
  padding-right: 0;
  padding-bottom: 0;
  padding-left: 0;
  width: 100%;

  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    background-color: var(--fabric-color-action-primary-background-default);
    border-top-width: 0;
    border-right-width: 0;
    border-bottom-width: 0;
    border-left-width: 0;
    border-top-left-radius: 50%;
    border-top-right-radius: 50%;
    border-bottom-right-radius: 50%;
    border-bottom-left-radius: 50%;
    height: ${thumbSize};
    width: ${thumbSize};
  }

  &::-moz-range-thumb {
    background-color: var(--fabric-color-action-primary-background-default);
    border-top-width: 0;
    border-right-width: 0;
    border-bottom-width: 0;
    border-left-width: 0;
    border-top-left-radius: 50%;
    border-top-right-radius: 50%;
    border-bottom-right-radius: 50%;
    border-bottom-left-radius: 50%;
    height: ${thumbSize};
    width: ${thumbSize};
  }
`;

export const timeRowStyle = css`
  align-items: center;
  color: var(--fabric-color-text-secondary);
  display: flex;
  font-feature-settings: 'tnum';
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
`;

export const inlineProgressStyle = css`
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: auto;
  min-width: 0;
`;

export const compactControlsStyle = css`
  align-items: center;
  display: flex;
  row-gap: 0;
  column-gap: 0;
  justify-content: center;
`;

export const inlineControlsStyle = css`
  align-items: center;
  display: inline-flex;
  row-gap: 0;
  column-gap: 0;
  padding-inline-start: var(--fabric-space-padding-xxs);
`;

export const compactMenuProgressStyle = css`
  align-items: center;
  display: inline-flex;
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: 0%;
  row-gap: var(--fabric-number-n-1-px);
  column-gap: var(--fabric-number-n-1-px);
  min-width: 138px;
`;

export const compactMenuControlStyle = css`
  align-self: stretch;
  align-items: center;
  border-inline-start-width: 1px;
  border-inline-start-style: solid;
  border-inline-start-color: var(--fabric-color-border-subtle);
  display: inline-flex;
  padding-inline-start: var(--fabric-space-padding-xxs);
`;

export const speedControlStyle = css`
  align-self: stretch;
  align-items: center;
  justify-content: center;
  border-inline-start-width: 1px;
  border-inline-start-style: solid;
  border-inline-start-color: var(--fabric-color-border-subtle);
  display: inline-flex;
  margin-inline-start: var(--fabric-space-gap-xs);
  padding-inline-start: var(--fabric-space-padding-xs);
  padding-inline-end: var(--fabric-space-padding-xs);
`;

export const speedButtonStyle = css`
  width: 4ch;
`;

export const backwardSkipButtonStyle = css`
  .button-icon {
    transform: scaleX(-1);
  }
`;

export const hiddenAudioStyle = css`
  display: none;
`;
